export enum ECounterpartyEmissionSearchForm {
  CounterpartyName= 'counterpartyName',
  WalletAccountGUID = 'wallet_account_guids',
}

export enum ERowAction {
  Edit = 'edit',
  Delete = 'delete',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EAccountManagementCounterpartyEmissionPageGetParams {
  Action = 'action',
}

export enum EAccountManagementCounterpartyEmissionPageGetParamsActionTypes {
  Create = 'create',
}
